const validateEmail = (mail) => {
  if (mail.includes('@') && mail.includes('.')) {
    return true;
  }
  return false;
};

export default validateEmail;
